import { ContentCluster } from '@app/components/base/content-structure/ContentCluster';
import { SocialPublishAtField } from '@app/modules/social-export/components/inputs/SocialPublishAtField';
import { TextFieldElementWithEmoji } from '@app/modules/social-export/components/inputs/TextFieldElementWithEmoji';
import { PublishFormUnsavedChangesWarning } from '@app/modules/social-export/components/PublishFormUnsavedChangesWarning';
import { BaseExportFormProps } from '@app/modules/social-export/hooks/social-export-form-props';
import { zodResolver } from '@hookform/resolvers/zod';
import { FormContainer } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { TwitterPublishDto, TwitterSettingsDto } from '../../social-export.types';
import { TwitterPublishValues, useTwitterPublishSchema } from './useTwitterPublishSchema';

type TwitterPublishFormProps = BaseExportFormProps<TwitterPublishDto, TwitterSettingsDto>;

export function TwitterPublishForm({ source, onUpload, actions }: TwitterPublishFormProps) {
  const { $t } = useIntl();
  const schema = useTwitterPublishSchema();
  const initialValues: TwitterPublishValues = {
    content: source.description ?? '',
    publishAt: null,
  };

  const beforeSubmit = (data: TwitterPublishValues): TwitterPublishDto => ({
    description: data.content,
    publishAt: data.publishAt || undefined,
  });

  return (
    <FormContainer
      values={initialValues}
      mode="onBlur"
      resolver={zodResolver(schema)}
      onSuccess={async (formData) => {
        await onUpload(beforeSubmit(formData));
      }}
    >
      <PublishFormUnsavedChangesWarning />
      <ContentCluster
        title={$t({
          id: 'socialExport.form.content',
          defaultMessage: 'Contenido',
        })}
      >
        <TextFieldElementWithEmoji
          name="content"
          label={$t({
            id: 'socialExport.form.content',
            defaultMessage: 'Contenido',
          })}
          required
          fullWidth
          multiline
          rows={3}
        />
      </ContentCluster>
      <ContentCluster
        title={$t({
          id: 'socialExport.form.scheduling',
          defaultMessage: 'Programación',
        })}
      >
        <SocialPublishAtField />
      </ContentCluster>
      {actions}
    </FormContainer>
  );
}
